import { IMutations } from '@/interfaces/store.interfaces';
import { CopilotServiceApplication } from '@/application/copilot-service-application';
import { initialState } from '@/store/state';
const mutations: IMutations = {
	setAreDependenciesLoaded: (value) => {
		CopilotServiceApplication.Store.state.areDependenciesLoaded = value;
	},
	changeChatSessionId: (value) => {
		CopilotServiceApplication.Store.state.chatSessionId = value;
	},
	changeChatHistory: (value) => {
		CopilotServiceApplication.Store.state.chatHistory = value;
	},
	setUserSessions: (value) => {
		CopilotServiceApplication.Store.state.userSessions = value;
	},
	setUserNationalityCountryIso: (value) => {
		CopilotServiceApplication.Store.state.userNationalityCountryIso = value;
	},
	setUserCurrency: (value) => {
		CopilotServiceApplication.Store.state.userCurrency = value;
	},
	setCanLoadUserSession: (value) => {
		CopilotServiceApplication.Store.state.canLoadUserSession = value;
	},
	setSidebarOpen: (value) => {
		CopilotServiceApplication.Store.state.isSidebarOpen = value;
	},
	setShouldShowFooter: (value) => {
		CopilotServiceApplication.Store.state.shouldShowFooter = value;
	},
	setUserId: (value) => {
		CopilotServiceApplication.Store.state.userId = value;
	},
	setBestfitCompletness: (value) => {
		CopilotServiceApplication.Store.state.bestfitCompletness = value;
	},
	setActiveStudyId: (value) => {
		CopilotServiceApplication.Store.state.activeStudyId = value;
	},
	resetState: () => {
		CopilotServiceApplication.Store.state.activeStudyId = initialState.activeStudyId;
		CopilotServiceApplication.Store.state.areDependenciesLoaded = initialState.areDependenciesLoaded;
		CopilotServiceApplication.Store.state.chatSessionId = initialState.chatSessionId;
		CopilotServiceApplication.Store.state.chatHistory = initialState.chatHistory;
		CopilotServiceApplication.Store.state.userSessions = initialState.userSessions;
		CopilotServiceApplication.Store.state.userNationalityCountryIso = initialState.userNationalityCountryIso;
		CopilotServiceApplication.Store.state.userCurrency = initialState.userCurrency;
		CopilotServiceApplication.Store.state.canLoadUserSession = initialState.canLoadUserSession;
		CopilotServiceApplication.Store.state.isSidebarOpen = initialState.isSidebarOpen;
		CopilotServiceApplication.Store.state.shouldShowFooter = initialState.shouldShowFooter;
		CopilotServiceApplication.Store.state.bestfitCompletness = initialState.bestfitCompletness;
		CopilotServiceApplication.Store.state.userId = initialState.userId;
	}
};

export default mutations;
